import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app';
import { MobileRuntimeService } from './app/services/mobile-runtime.service';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => appRef.injector.get(MobileRuntimeService).initialize())
  .catch((err) => console.error(err));
